<div>
    <h2 class="text-primary">Welcome to the new site!</h2>
    <h3>To recieve your original account XP you must register a new account with the email used by your original Cof
        Airsoft account.
    </h3>
    <h3>You may also Login/Register using Google,
        <p class="text-danger">*Note the Gmail email address must match your
            original Cof Airsoft email to receive your original COfAirsoft account XP</p>
    </h3>
</div>